import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {trackEvent} from '../../tracking/amplitude/TrackingV2';
import {UpdateDeliverableInput, UpdateDeliverableMutation} from './__generated__/UpdateDeliverableMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

const mutation = graphql`
	mutation UpdateDeliverableMutation($input: UpdateDeliverableInput!) {
		updateDeliverable(input: $input) {
			deliverable {
				node {
					id
					name
					description
					price
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<UpdateDeliverableInput>,
	onSuccess?: RelayOnCompleted<UpdateDeliverableMutation>,
	onError?: RelayOnError
): Disposable {
	trackEvent('Deliverable', 'Updated', input);

	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
